import {getParentWidth, getValue, isPage, isSection} from '../utils'
import type {CalculateParams} from '../types'
import {convertWidthToPx} from '../converters/width'
import {CANVAS_WIDTH} from '../constants'

export const calculateWidth = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, extensionAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.width(compRef) !== undefined) {
        return
    }

    const {componentLayout} = layoutData
    const {width} = componentLayout ?? {}

    if (isSection(extensionAPI, compRef) || isPage(extensionAPI, compRef)) {
        set.width(compRef, CANVAS_WIDTH)
    } else if (!width?.type) {
        set.width(compRef, getParentWidth(calculateParams))
    } else {
        const widthInPx = convertWidthToPx[width.type]({
            ...calculateParams,
            value: getValue(width)
        })
        set.width(compRef, widthInPx)
    }
}
